export default __webpack_public_path__ + "static/media/IMG_1868.eac1b1e2.jpeg";